/**
 * Layout tuning for the onboarding hero art (see tutorialHeroArtLayout.helper).
 * One reference size per scene's hero element; scenes lay everything else out with flex.
 */
export const TUTORIAL_HERO_LAYOUT = {
  REF_WIDTH: 360,
  MIN_SCALE: 0.68,
  MAX_SCALE: 1.08,
  /** Screen 1 hook mascot. */
  HOOK_MASCOT: 210,
  /** Screen 2 head-to-head avatar (You / rival) — full-figure ready avatars facing each other. */
  VS_AVATAR: 116,
  /** Screen 3 live layered mascot. */
  CLIMB_MASCOT: 188,
} as const;
